import { render, staticRenderFns } from "./NationalECN2024.vue?vue&type=template&id=3ac25fbf&scoped=true"
import script from "./NationalECN2024.vue?vue&type=script&lang=js"
export * from "./NationalECN2024.vue?vue&type=script&lang=js"
import style0 from "./NationalECN2024.vue?vue&type=style&index=0&id=3ac25fbf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac25fbf",
  null
  
)

export default component.exports